module.exports = __webpack_public_path__ + "static/media/treadmill.230e12a6.png";